import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const PersonAddAltIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"person_add_alt"} ref={ref}/>
});

PersonAddAltIcon.displayName = "PersonAddAltIcon";
